import { render, staticRenderFns } from "./ViewMessages.vue?vue&type=template&id=468cb79f&scoped=true"
import script from "./ViewMessages.vue?vue&type=script&lang=js"
export * from "./ViewMessages.vue?vue&type=script&lang=js"
import style0 from "./ViewMessages.vue?vue&type=style&index=0&id=468cb79f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468cb79f",
  null
  
)

export default component.exports